import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import styled from 'styled-components';
import {Grid} from "@material-ui/core";
import { getInvitedToCompanies } from 'store/state/guest'
import GuestCompanyTable from "./GuestCompanyTable";
import Logo from "lib/images/lb_LogoSmall.png";

const styles = {
  root: {
    flexGrow: 1,
  },
};
const StyledContainer = styled.div`
text-align: center;
`;
const StyledHeader = styled.div`
color:rgb(170, 170, 170);

font-family:Roboto-Light, "Roboto Light", Roboto, sans-serif;
font-feature-settings:"kern";
font-kerning:normal;
font-size:40px;
font-style:normal;
font-weight:200;
height:auto;
letter-spacing:normal;
line-height:normal;
overflow-wrap:break-word;
text-align:center;
text-rendering:optimizelegibility;
text-transform:none;
`
const StyledSubHeader = styled.div`
color:rgb(51, 51, 51);
font-family:Roboto-Regular, Roboto, sans-serif;
font-feature-settings:"kern";
font-kerning:normal;
font-size:16px;
font-style:normal;
font-weight:400;
height:auto;
letter-spacing:normal;
line-height:normal;
overflow-wrap:break-word;
text-align:center;
text-rendering:optimizelegibility;
text-transform:none;
margin-bottom: 25px;
`
export class GuestLanding extends Component {

    state = {}

    componentDidMount(){
      this.props.getInvitedToCompanies({id: this.props.authentication.user.contact.id});
    }
    componentDidUpdate(){}
    
    render(){
      const { classes } = this.props;
        return (<Grid container className={classes.root}                       
                      xs={12}>
                  <Grid item xs={12}>
                    <StyledContainer>
                      <img src={Logo} id="homeLogo" className="Guest-App-logo" alt="logo" />                    
                      <StyledHeader>Welcome to</StyledHeader>
                      <StyledHeader>LoanBoss!</StyledHeader>
                      <StyledSubHeader>Select a company from the list below to view the deals you have been invited to.</StyledSubHeader>
                    </StyledContainer>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container direction="row" justify="flex-end" alignItems="center">
                      <Grid item xs={2}></Grid>
                      <Grid item xs={7}>
                        <GuestCompanyTable records={this.props.invitedToCompanies}/>
                      </Grid>
                      <Grid item xs={3}></Grid>
                    </Grid>
                  </Grid>
                </Grid>)
    }

}


const mapStateToProps = ({ authentication, guest }) => ({
    authentication,
    invitedToCompanies: guest.invitedToCompanies
  });
  
  export default compose(
    connect(mapStateToProps,{
      getInvitedToCompanies
    }),
    withStyles(styles),
  )(GuestLanding);